import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const isUrl = (value) => /^https?:\/\/\S+$/i.test(value.trim());
const SourceAttribution = (props) => {
    var _a;
    const source = props.source.trim();
    const hidePreTextOnSourceUnavailable = (_a = props.hidePreTextOnSourceUnavailable) !== null && _a !== void 0 ? _a : false;
    return !source && !props.addedByName ? null : (_jsxs("span", { className: "text-muted d-flex", style: { fontSize: '0.7rem' }, children: [_jsx("span", { className: "flex-shrink-0 me-1", children: 'Source:' }), source
                ? isUrl(source)
                    ? _jsx("a", { href: source, target: "_blank", rel: "noopener noreferrer", title: source, className: "text-truncate", children: source })
                    : _jsx("span", { title: source, className: "text-truncate", children: source })
                : _jsx("span", { children: hidePreTextOnSourceUnavailable ? props.addedByName : `Uploaded by ${props.addedByName}` })] }));
};
export default SourceAttribution;
